import styled, { css } from 'styled-components/native';

import { warrior } from '../../../../constants/color';
import Image from '../../../../elements/Image';

export const TITLE_LINE_HEIGHT = 21;
const BADGE_WIDTH = 34;

const titleMaxWidth = css<{ showBadgeAndSectionWidth?: number | false }>`
  ${({ showBadgeAndSectionWidth }) =>
    showBadgeAndSectionWidth
      ? `max-width: ${showBadgeAndSectionWidth - BADGE_WIDTH}px;`
      : ''}
`;

export default {
  Title: styled.Text<{ showBadgeAndSectionWidth?: number | false }>`
    color: ${warrior};
    font-size: 15px;
    font-weight: 600;
    line-height: ${TITLE_LINE_HEIGHT}px;
    ${titleMaxWidth}
  `,
  TitleSection: styled.View`
    flex-direction: row;
    align-items: center;
  `,
  Badge: styled(Image)`
    margin-left: 8px;
    width: ${BADGE_WIDTH}px;
    height: 16px;
  `,
};
